{
  "Common": {
    "class-label": "Class"
  },
  "CartPage": {
    "title": "Your Cart",
    "empty": "Your cart is empty.",
    "merchant-label": "Provided by"
  },
  "ServiceItemCard": {
    "add-to-cart": "Add to cart"
  },
  "Header": {
    "about": "About",
    "brand": "Raytio Marketplace",
    "merchants": "Merchants",
    "sign-in": "Sign in",
    "sign-up": "Sign up",
    "services": "Services",
    "sign-out": "Sign out"
  },
  "Footer": {
    "blurb": "The institutional trust layer for modern commerce. Verified identities, authenticated services, and secure appointments.",
    "platform": "Platform",
    "verified-merchants": "Verified Merchants",
    "service-catalog": "Service Catalog",
    "how-verification-works": "How Verification Works",
    "rights": "© {year} Raytio. All rights reserved."
  },
  "HomePage": {
    "badge": "Cryptographically verified",
    "title-line1": "Trust",
    "title-line2": "Marketplace",
    "subtitle": "A public directory of merchants and service providers whose identity and credentials are verified on the Raytio network. Search, compare, and book with confidence.",
    "search-placeholder": "Search merchants, services, or specialties…",
    "search-button": "Search",
    "trust-identity": "Identity verified",
    "trust-credentials": "Credentials on-chain",
    "trust-booking": "Instant booking",
    "stat-verified-entities": "Verified Entities",
    "stat-total-merchants": "Total Merchants",
    "stat-active-services": "Active Services",
    "verified-merchants": "Verified Merchants",
    "featured-subtitle": "Trusted providers ranked by verification tier and network reputation.",
    "view-all": "View all",
    "how-eyebrow": "How it works",
    "how-title": "Trust built into every layer.",
    "how-subtitle": "Unlike standard directories, every Raytio entity has undergone cryptographic proof of identity before their profile goes live.",
    "feature-1-title": "Identity proofing",
    "feature-1-desc": "Directors and practitioners undergo biometric and document verification to establish initial trust.",
    "feature-2-title": "Entity validation",
    "feature-2-desc": "Business registries and medical boards are queried via secure APIs to confirm active, unencumbered status.",
    "feature-3-title": "Cryptographic issuance",
    "feature-3-desc": "Verified entities receive a verifiable credential, powering the badges you see across the marketplace.",
    "cta-title": "Ready to find a verified provider?",
    "cta-subtitle": "Browse the full directory or explore services by category.",
    "cta-browse": "Browse merchants",
    "cta-explore": "Explore services"
  },
  "Verification": {
    "verified": "Verified Identity",
    "pending": "Verification Pending",
    "unverified": "Unverified"
  },
  "Pagination": {
    "label": "Pagination",
    "previous": "Previous page",
    "next": "Next page"
  },
  "MerchantClass": {
    "CLASS_1": "Gold",
    "CLASS_2": "Silver"
  },
  "MerchantsPage": {
    "eyebrow": "Directory",
    "title": "Verified Merchants",
    "subtitle": "Every merchant listed here has passed Raytio's identity and credential verification. Filter to find the right provider for you.",
    "no-merchants": "No merchants found.",
    "found": "{count, plural, one {Found # merchant} other {Found # merchants}}",
    "filter-search": "Search",
    "filter-country": "Country",
    "filter-category": "Category",
    "clear-filters": "Clear filters"
  },
  "MerchantCard": {
    "unnamed": "Unnamed Merchant",
    "verified": "Verified",
    "services": "{count, plural, one {# Service} other {# Services}}"
  },
  "MerchantDetail": {
    "active": "Active",
    "approved": "Approved",
    "default-description": "View this merchant on Raytio Trust Marketplace.",
    "forms-heading": "Required Forms & Access",
    "forms-sign-in-button": "Sign in to view forms",
    "forms-sign-in-prompt": "Sign in with your Raytio account to view this merchant's forms.",
    "forms-sign-up-button": "Sign up to view forms",
    "forms-sign-up-prompt": "Don't have an account? Sign up to access this merchant's forms.",
    "locations": "Locations",
    "no-address": "No address available",
    "no-forms-available": "No forms available",
    "not-found": "Merchant Not Found",
    "open-form": "Open form",
    "primary-use": "Primary",
    "services-offered": "Services Offered",
    "sign-in-prompt": "Sign in with your Raytio account to see branch details and locations for this merchant.",
    "sign-in-to-view": "Sign in to view locations",
    "unnamed": "Unnamed Merchant",
    "view-details": "View details",
    "view-price-list": "View price list"
  },
  "CountryFilter": {
    "all-countries": "All countries",
    "filter-by-country": "Filter by country"
  },
  "CategoryFilter": {
    "placeholder": "Filter by category…",
    "clear": "Clear",
    "no-results": "No categories found"
  },
  "ServiceCategoryFilter": {
    "placeholder": "Jump to a service category…",
    "no-results": "No categories found"
  },
  "SearchBar": {
    "placeholder": "Search merchants..."
  },
  "ThemeToggle": {
    "light-mode": "Switch to light mode",
    "dark-mode": "Switch to dark mode"
  },
  "AboutPage": {
    "eyebrow": "About",
    "hero-title": "About the Trust Marketplace",
    "hero-subtitle": "A public directory of verified merchants and trusted service providers — every listing backed by cryptographic verification.",
    "what-is-title": "What is the Trust Marketplace?",
    "what-is-p1": "The Raytio Trust Marketplace is a public directory of verified merchants and service providers. Every listing is backed by cryptographic verification, ensuring the information you see is authentic and trustworthy.",
    "what-is-p2": "Unlike standard directories where anyone can claim to be a provider, the Trust Marketplace requires cryptographic proof of identity and business registration before a profile is made public.",
    "how-title": "How Verification Works",
    "step-1-title": "1. Identity Proofing",
    "step-1-desc": "Directors and individuals undergo biometric and document verification through the Raytio platform to establish initial trust.",
    "step-2-title": "2. Entity Validation",
    "step-2-desc": "Business registries and authorities are queried via secure APIs to confirm active, unencumbered status.",
    "step-3-title": "3. Cryptographic Issuance",
    "step-3-desc": "Each verification is digitally signed and independently auditable, issued as a verifiable credential that powers the \"Verified\" badges across the marketplace.",
    "get-listed-title": "Get Listed",
    "get-listed-body": "Want to showcase your business on the Trust Marketplace? You must first complete the Raytio verification flow to get started.",
    "get-listed-button": "Start verification process",
    "get-listed-helper": "You will be redirected to the Raytio Identity Portal to begin your application."
  },
  "ServicesPage": {
    "eyebrow": "Catalog",
    "title": "Service Catalog",
    "subtitle": "Browse verified services and procedures by category, then compare and book with providers you can trust.",
    "no-services": "No services available.",
    "services-count": "{count, plural, one {# service} other {# services}}",
    "subcategories": "{count, plural, one {# Subcategory} other {# Subcategories}}",
    "view-providers": "View providers"
  },
  "ServiceCategoryPage": {
    "breadcrumb-services": "Services",
    "no-merchants": "No providers found for this service.",
    "not-found": "Service Not Found",
    "search-placeholder": "Search providers...",
    "sign-in-to-view": "Sign in to view providers",
    "sign-in-prompt": "Sign in with your Raytio account to see providers for this service.",
    "sign-up-prompt": "Don't have an account? Sign up to see providers for this service.",
    "sign-up-to-view": "Sign up to view providers"
  },
  "ServiceMerchantPage": {
    "breadcrumb-services": "Services",
    "items-title": "Specific Offerings",
    "no-items": "No products or services listed.",
    "not-found": "Not Found",
    "show-details": "Show details",
    "hide-details": "Hide details",
    "trust-statement": "This provider is cryptographically authenticated and certified to provide services in the {category} category. All credentials have been verified by the Raytio Trust Engine."
  },
  "RequestService": {
    "title": "Request Service",
    "blurb": "Book an appointment or request service details securely through the marketplace.",
    "assurance-identity": "Verified Identity Assurance",
    "assurance-channel": "Secure Communication Channel",
    "assurance-data": "Encrypted Health Data",
    "book": "Book appointment",
    "view-profile": "View full provider profile"
  },
  "CtaBar": {
    "coming-soon": "Coming soon",
    "book": "Book"
  },
  "ServiceItemAttributes": {
    "no-data": "No attribute data available."
  },
  "ServiceItemCard": {
    "inherited-price": "(standard rate)"
  },
  "PriceListPage": {
    "breadcrumb-merchants": "Merchants",
    "title": "Price List",
    "heading": "{merchant} — Public Price List",
    "subtitle": "Publicly listed prices for services offered by this merchant. Prices reflect the merchant's published rates and may include standard rates where no merchant-specific price is set.",
    "col-item": "Service",
    "col-price": "Price",
    "no-offers": "This merchant has not published any public prices.",
    "no-price": "Contact for pricing",
    "inherited": "(standard rate)"
  },
  "Persona": {
    "issued": "Issued",
    "expires": "Expires",
    "last-verified": "Last verified",
    "self-asserted-note": "Name and bio are self-asserted and unverified",
    "profile-url": "Profile",
    "claim-verification": "Verification",
    "claim-reputation": "Reputation",
    "section-verifications": "Verifications",
    "section-social": "Connected Accounts",
    "section-reputation": "Reputation",
    "section-other": "Other Claims",
    "no-claims": "This profile has no published claims yet.",
    "rating": "Rating",
    "activity": "Activity",
    "member-since": "Member since",
    "not-found-title": "Profile Not Found",
    "not-found-description": "The requested profile could not be found.",
    "canonical-payload": "Signed payload",
    "signature": "Signature",
    "signing-key": "Signing key",
    "verify": "Verify signature",
    "verifying": "Verifying…",
    "verify-valid": "Signature valid",
    "verify-invalid": "Signature does not match",
    "verify-no-key": "No signing key recorded — cannot verify",
    "verify-error": "Could not retrieve the signing key",
    "signed": "Signed",
    "verified": "Verified",
    "view-signed-data": "View signed data",
    "hide-signed-data": "Hide signed data",
    "verify-again": "Verify again",
    "try-again": "Try again",
    "verify-valid-detail": "Checked in your browser against Raytio's published key.",
    "verify-valid-caveat": "A valid signature proves Raytio asserted this — not that it is true or complete.",
    "verify-invalid-detail": "This claim may have been altered.",
    "trust-note": "Each signed claim below carries an RSA-PSS signature from Raytio. Expand one to read the exact bytes that were signed and check them in your own browser — you don't have to take this page's word for anything.",
    "attested-claims-title": "Attested claims",
    "claims-summary": "{count, plural, one {# signed by Raytio · check it yourself} other {# signed by Raytio · check any of them yourself}}",
    "open-profile": "Open profile",
    "trust-note-label": "About attested claims",
    "reputation-note": "Bucketed on purpose — Raytio never publishes exact counts.",
    "stat-activity": "Activity",
    "stat-as-buyer": "As buyer",
    "stat-as-seller": "As seller",
    "stat-reviews": "Reviews",
    "stat-none-yet": "None yet",
    "reputation-note-label": "About these figures"
  },
  "BuyPage": {
    "title": "Choose your session",
    "slot-label": "Slot {slotNumber}",
    "choose-duration": "Select a duration",
    "in-use-title": "This slot is in use",
    "in-use-body": "This slot currently has an active session. Please check back shortly.",
    "halted-title": "Purchase in progress",
    "halted-body": "Someone is completing a purchase for this slot. Please wait a moment and try again.",
    "no-options": "No options are available for this slot."
  },
  "BookingPage": {
    "eyebrow": "Booking",
    "title": "Book an Appointment",
    "subtitle": "Search across verified providers for available slots.",
    "card-title": "Find available slots",
    "service-label": "Service",
    "service-placeholder": "Select a service category…",
    "clear-service": "Clear service",
    "or-change": "or change below",
    "location-label": "Location",
    "location-placeholder": "City, postcode, or coordinates",
    "use-my-location": "Use my location",
    "radius-label": "Within",
    "window-label": "Availability window",
    "next": "Next",
    "days-label": "days",
    "search": "Search availability",
    "searching": "Searching providers...",
    "progress": "Searched {completed} of {total} providers",
    "results-title": "Available Slots",
    "searched-providers": "Searched {count, plural, one {# provider} other {# providers}}",
    "sort-soonest": "Soonest",
    "sort-closest": "Closest",
    "sort-provider": "By Provider",
    "no-results-title": "No availability found",
    "no-results": "We couldn't find any available slots matching your criteria within the next 14 days. Try expanding your search radius or date range.",
    "search-failed": "Search failed. Please try again.",
    "search-timed-out": "Search timed out. Some providers may not have responded.",
    "book": "Book",
    "session-expired": "Your session has expired. Please sign in again to continue searching.",
    "sign-in-to-search": "Sign in to search",
    "sign-in-prompt": "Sign in with your Raytio account to search for available appointments.",
    "sign-up-prompt": "Don't have an account? Sign up to search for available appointments.",
    "sign-up-to-search": "Sign up to search",
    "km-away": "{distance} km away",
    "my-location": "My Location",
    "location-permission-denied": "Location permission was denied. Please enter an address instead.",
    "location-unavailable": "Could not determine your location. Please enter an address instead.",
    "view-list": "List",
    "view-calendar": "Calendar"
  },
  "Calendar": {
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "all": "All",
    "book": "Book",
    "close": "Close",
    "move": "Move detail window",
    "move-reset": "Move detail window (double-click to snap back)",
    "no-slots-day": "No available slots for this day.",
    "more-slots": "+{count} more",
    "slot-count": "{count, plural, one {# slot} other {# slots}}"
  }
}
